var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('EnvProvider',[_c('Layout',{attrs:{"menu-items":_vm.menuItems}},[_c('transition',{attrs:{"name":"eki-fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }